"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValuesSelector = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../../common");
const feature_flags_1 = require("../../../../../../feature-flags");
const hooks_1 = require("../../../../../../hooks");
const localization_1 = require("../../../../../../localization");
const attributes_1 = require("../../../../../components/attributes");
const formal_attributes_1 = require("../../../../../formal-attributes");
const store_1 = require("../../../../../../store");
const AttributeValuesSelector = ({ onOptionChange, selected, filter }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isMultiFacetNavEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFacetNav);
    const attributeValuesMap = (0, store_1.useAttributeValuesMap)(isMultiFacetNavEnabled);
    const { getAttributeName, getAttributeValueName } = (0, formal_attributes_1.useFormalAttributes)();
    const selectedAttributeValues = (!isMultiFacetNavEnabled
        ? attributeValuesMap.get(filter.fieldSpecifier)
        : attributeValuesMap[filter.fieldSpecifier]);
    const options = (0, react_1.useMemo)(() => selectedAttributeValues === null || selectedAttributeValues === void 0 ? void 0 : selectedAttributeValues.map((attribute) => ({
        label: (0, attributes_1.getAttributeValueTitle)({ subAttribute: attribute, getAttributeName, getAttributeValueName }),
        value: JSON.stringify({ id: attribute.valueId, name: attribute.valueName }),
    })), [selectedAttributeValues, getAttributeName, getAttributeValueName]);
    return (react_1.default.createElement(common_1.AutocompleteSelector, { options: options !== null && options !== void 0 ? options : [], onChange: onOptionChange, selected: selected, placeholder: t({ key: 'VALUE' }) }));
};
exports.AttributeValuesSelector = AttributeValuesSelector;
exports.default = exports.AttributeValuesSelector;
